module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classColumns
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Tipo de preço padrão",
      "columns": _vm.numberColumns,
      "error": _vm.getError('price.type')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.type),
      expression: "input.type"
    }],
    staticClass: "form-select",
    attrs: {
      "disabled": _vm.block
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.input, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.priceTypeDI), function(priceType) {
    return _c('option', {
      domProps: {
        "value": priceType
      }
    }, [_vm._v("\n          " + _vm._s(priceType === 'source' ? _vm.$t('priceTypeModule.label') + _vm.$t(_vm.moduleLabel) : _vm.$t(priceType).label) + "\n        ")])
  })], 2)]), _vm._v(" "), (_vm.input.type === 'percent') ? _c('form-group', {
    attrs: {
      "label": "Percentual",
      "columns": 6,
      "required": true
    }
  }, [_c('div', {
    staticClass: "form-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.percent),
      expression: "input.percent"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.input.percent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.input, "percent", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-addon"
  }, [_vm._v("%")])])]) : _vm._e(), _vm._v(" "), (_vm.input.type === 'fixedValue') ? _c('form-group', {
    attrs: {
      "label": "Valor fixo",
      "columns": 6,
      "required": true
    }
  }, [_c('div', {
    staticClass: "form-flex"
  }, [_c('money', _vm._b({
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.input.fixedValue),
      callback: function($$v) {
        _vm.$set(_vm.input, "fixedValue", $$v)
      },
      expression: "input.fixedValue"
    }
  }, 'money', _vm.money, false))], 1)]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00487d58","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ProductPriceConfiguration.vue
// module id = 2860
// module chunks = 0